import Cookies from 'js-cookie';

window.addEventListener('forms.success', (e) => {
    const { form, payload } = e.detail;

    if (payload.phone && !payload.phone.startsWith('+')) {
        console.info(payload);
        console.error(new Error('Phone number is not in international format'));
    }

    const leadData = form.getAttribute('lead-source');

    if (!leadData || Cookies.get('user_is_lead')) {
        return;
    }

    const parsedData = JSON.parse(leadData);

    if (parsedData) {
        Cookies.set('user_is_lead', true);
        Cookies.set('user_lead_source', JSON.stringify(parsedData));
    }
});
